import { Injectable } from "@angular/core";
import { IStorageOrder } from "src/app/Models/Interface/StorageOrder/storage-order";
import { EVariables } from "src/app/Models/Enum/variables";
import { UserDetailsService } from "../../../Components/Services/user-details.service";
import { IOrderProducts } from "src/app/Models/Interface/Shop/Order/order";

@Injectable({
  providedIn: "root",
})
export class StorageOrderService {
  private orderList: IStorageOrder[] = [];
  order = this.getOrder()
    ? this.getOrder()
    : ({ shoppingCart: [] } as unknown as IStorageOrder);

  constructor(private userDetailsService: UserDetailsService) {}

  setOrderInLocalStorage(): void {
    this.order.shoppingCartForSearch = this.order.shoppingCart;
    this.order.categiryData = this.getCategoryDetails(this.order.shoppingCart);
    localStorage.setItem(
      EVariables.Orders + this.userDetailsService.user.userId,
      JSON.stringify(this.order)
    );
  }

  removeOrderFromLocalStorage(): void {
    localStorage.removeItem(
      EVariables.Orders + this.userDetailsService.user.userId
    );
  }

  getOrder(): IStorageOrder {
    // @ts-ignore
    if (
      JSON.parse(
        localStorage.getItem(
          EVariables.Orders + this.userDetailsService.user.userId
        )!
      )
    ) {
      // @ts-ignore
      this.order = JSON.parse(
        localStorage.getItem(
          EVariables.Orders + this.userDetailsService.user.userId
        )!
      );
    }
    // @ts-ignore
    return JSON.parse(
      localStorage.getItem(
        EVariables.Orders + this.userDetailsService.user.userId
      )!
    );
  }

  onAddArrOfOrders(): void {
    localStorage.setItem(
      EVariables.Orders + this.userDetailsService.user.userId,
      JSON.stringify(this.orderList)
    );
  }

  getCategoryDetails(products: IOrderProducts[]): any[] {
    let hash = {};
    let commTypes = [];

    for (let i = 0; i < products.length; i++) {
      let cat = products[i].category;
      // @ts-ignore
      if (!hash[cat]) {
        commTypes.push({
          category: products[i].category,
          categoryId: products[i].categoryId,
          items: products.filter((c) => c.category === cat).length,
          price: products
            .filter((c) => c.category === cat)
            .reduce((a, b) => a + b.total, 0),
        });
        // @ts-ignore
        hash[cat] = true;
      }
    }
    return commTypes;
  }
}
